import templateUrl from 'emun.invoice/credit-memo-details-header.htm'

export default {
    bindings: {
        creditmemo: '<'
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};
